/* eslint-disable */
import React from "react";
import ReactResizeDetector from "react-resize-detector";
import mapboxgl from "!mapbox-gl";
// import mapboxgl from "mapbox-gl/dist/mapbox-gl-csp";

// import { COLOR } from "../Graphs/StyleMapper";
import "mapbox-gl/dist/mapbox-gl.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltLeft } from "@fortawesome/pro-solid-svg-icons";
import { faHandPointer } from "@fortawesome/pro-regular-svg-icons";
// import { Utilities } from '../Utilities';
// import { ga } from '../GoogleAnalytics';
// import { MAP_COLORS } from './MapStyles';
import "./JSBaseMap.scss";
import * as d3 from "d3";
import _ from "lodash";
import { locateTooltip } from "../misc";

// mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const MAP_COLORS = {
    OCEAN: "red",
    QLD: "green",
    NOTFOUNDFILL: "blue",
    MASK: "white",

    // NOTFOUNDFILL: COLORS.GREY2,
    // UNSELECTED_POLYGON_FILL: "#AAAAAA",
    // UNSELECTED_POLYGON_STROKE: "#EEEEEE",
    // SELECTED_POLYGON_STROKE: "#FFFFFF",

    MOUSEOUT_POLYGON_STROKE: "grey",
    MOUSEENTER_POLYGON_STROKE: "black"
};

// const processors = {
//     locateTooltip: ({ d3Tooltip, event }) => {
//         if (!d3Tooltip) return;

//         const left = d3.max([
//             40,
//             d3.min([event.pageX - 50, window.innerWidth - d3Tooltip.node().getBoundingClientRect().width - 40])
//         ]);

//         d3Tooltip
//             .style("display", "inline-block")
//             .style("left", left + "px")
//             .style("top", function () {
//                 var height = d3.select(this).node().getBoundingClientRect().height;
//                 return event.pageY - height * 1.2 + "px";
//             });
//     }
// };

// const tile = require("d3-tile").tile();
// const Pbf = require('pbf');
// const VectorTile = require('@mapbox/vector-tile').VectorTile;

// const DEFAULT_ONBOARDING = true;

// const locateTooltip = ({ d3Tooltip, event }) => {
//     if (!d3Tooltip)
//         return;

//     const left = d3.max([40, d3.min([event.pageX - 50, window.innerWidth - d3Tooltip
//         .node()
//         .getBoundingClientRect().width - 40])]);

//     d3Tooltip
//         .style("display", "inline-block")
//         .style("left", left + "px")
//         .style("top", function () {
//             var height = d3
//                 .select(this)
//                 .node()
//                 .getBoundingClientRect().height;
//             return event.pageY - height * 1.2 + "px";
//         });
// };

class Map extends React.Component {
    constructor(props) {
        super(props);
        this.element = {
            current: undefined
        };
        this.notFoundValueColor = MAP_COLORS.NOTFOUNDFILL;
        //this.notFoundValueColor = "red";

        this.minZoom = 0;
        this.maxZoom = 13;

        this.update = this.update.bind(this);
        this._drawMap = this.drawMap.bind(this);

        //this.featureClickHandler = this.featureClickHandler.bind(this);

        this.hashedSpatialValues = {};

        // this.state = {
        //     onBoardingCompleted: Utilities.getCookies('mapWzdCompleted', 'false') === 'true',
        // };
        this.state = {
            onBoardingCompleted: true
        };
    }

    // static getDerivedStateFromProps(nextProps, prevState) {
    //     let {
    //         onBoarding = false
    //     } = nextProps;
    //     let newState = _.merge({
    //         onBoarding
    //     }, prevState || {});
    //     return newState;
    // }

    render() {
        // console.log("map render");

        const {
            className,
            goNext,
            legendMappings: legends,
            colorMappings: leColors,
            legendItem,
            history,
            showLegend,
            back
        } = this.props;

        let { onBoardingCompleted } = this.state;

        let topLegends =
            showLegend === true && leColors && legends && legends.length > 1
                ? legends.map((d, index) => {
                      const legendBox = legendItem ? (
                          legendItem(d, leColors)
                      ) : (
                          <React.Fragment>
                              <div className="map-legend-item-box" style={{ background: leColors[d.value] }}>
                                  {d.boxLabel ?? ""}
                              </div>{" "}
                              <span>{d.label}</span>
                          </React.Fragment>
                      );
                      return (
                          <span key={index} className={`map-legend-item ${d.value}`}>
                              {legendBox}
                          </span>
                      );
                  })
                : null;

        return (
            <div className={`map ${className ?? ""}`} ref={this.element}>
                <div className="map-content"></div>

                {showLegend && <div className="map-legend">{topLegends}</div>}

                {!back ? null : (
                    <div
                        style={{
                            position: "absolute",
                            top: "5px",
                            left: "5px"
                        }}
                    >
                        <button className={"map-button"} onClick={back.onClick}>
                            <FontAwesomeIcon icon={faArrowAltLeft} />
                            &nbsp;&nbsp;{back.text}
                        </button>
                    </div>
                )}
                {onBoardingCompleted ? null : (
                    <div className="onboard">
                        <div>
                            <span className="hand-pointer">
                                <FontAwesomeIcon icon={faHandPointer} />
                            </span>
                        </div>
                        <div>
                            <span>
                                To <strong>view results by region or catchment</strong> select the area on the map or
                                use the menu dropdown above
                            </span>
                        </div>
                        <div>
                            <button
                                className={"confirm-button"}
                                onClick={() => {
                                    ga.logEvent(
                                        "confirmedInformationButton",
                                        "To view results by region or catchment select the area on the map or use the menu dropdown above",
                                        window.location.href
                                    );
                                    // Utilities.setCookies('mapWzdCompleted', 'true');
                                    // this.setState({ onBoardingCompleted: true });
                                }}
                            >
                                OK, Got it!
                            </button>
                        </div>
                    </div>
                )}

                <ReactResizeDetector handleWidth={true} handleHeight={true} onResize={this._drawMap} />
            </div>
        );
    }

    shouldComponentUpdate(nextProps, nextState, nextContent) {
        // const { current } = this.props ?? {};
        // const { onBoardingCompleted } = this.state;
        // const {
        //     report: n_report,
        //     measure: n_measure,
        //     area: n_area,
        //     year: n_year,
        //     file: n_file,
        //     visTemplateFile: n_visTemplateFile,
        // } = nextProps ?? {};
        // const { onBoardingCompleted: n_onBoardingCompleted } = nextState;

        // return (
        //     report != n_report ||
        //     measure !== n_measure ||
        //     area !== n_area ||
        //     year !== n_year ||
        //     onBoardingCompleted !== n_onBoardingCompleted ||
        //     (file || {}).id !== (n_file || {}).id ||
        //     (!(file || {}).data && !!(n_file || {}).data) ||
        //     (visTemplateFile || {}).id !== (n_visTemplateFile || {}).id ||
        //     (!(visTemplateFile || {}).data && !!(n_visTemplateFile || {}).data)
        // );

        // return true;

        const { shouldRenderMeta } = this.props ?? {};
        const { shouldRenderMeta: nShouldRenderMeta } = nextProps;

        if (!shouldRenderMeta || !nShouldRenderMeta) return true;

        const matches = _.keys(shouldRenderMeta ?? {}).map(
            key => (shouldRenderMeta ?? {})[key] === (nShouldRenderMeta ?? {})[key]
        );

        return matches.filter(d => d === false).length > 0;
    }

    componentWillReceiveProps(nextProps, nextContent) {
        //console.log("receive new props");
        // let {
        //     onBoardingCompleted = Utilities.getCookies("mapWzdCompleted", false)
        // } = nextProps;
        // this.setState({
        //     onBoardingCompleted
        // });
    }

    componentWillUnmount() {
        //console.log("will unmount");

        this.isCancelled = true;
        if (this.map) {
            this.map = null;
            this.contextLoaded = false;
            this.hoveredFeatureId = null;
        }

        if (this.tooltip) this.tooltip.remove();
    }

    componentDidMount() {
        // console.log("did mount");
        this.loadAndDraw();
        var guid = function () {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
        };

        this.tooltip = d3.select("body").append("div").attr("class", "vis-tooltip").attr("id", guid());
    }

    setupEvents() {}

    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log("did update");
        this.loadAndDraw();
    }

    loadAndDraw() {
        // this.loadGeo().then(data => {
        //     this.sources = data;
        //     this.drawMap();
        // });

        this.drawMap();
    }

    loadGeo() {
        const that = this;

        const sources = this.state.sources.map(d => {
            let sF = d.spatial ? Promise.resolve(d.spatial) : fetch(d.source).then(res => res.json());
            let valuesF = null;

            if (d.spatialValues) valuesF = Promise.resolve(d.spatialValues);
            else if (d.values !== null && d.values !== undefined && d.values !== "") valuesF = d3.csv(d.values);

            return Promise.all([sF, valuesF]);
        });

        return Promise.all(sources)
            .then(data => {
                if (that.state && that.state.sources && data.length !== that.state.sources.length)
                    throw new Error("One of the source does not exist");

                return data;
            })
            .catch(err => {
                console.log(err);
            });
    }

    getLegendData() {
        let legends = [];
        this.state.sources
            .filter(d => d.legend && d.legendMappings !== null && d.legendMappings !== undefined)
            .forEach(d => {
                if (typeof d.legendMappings === "string") legends.push({});
                return {
                    mappings: d.legendMappings,
                    colors: d.colorMappings
                };
            });

        //[{"data":[{"text":"Department","cssclasses":["department_legend"], "type": 7},{"text":"Divisions","cssclasses":["divisions_legend"]},{"text":"Others","cssclasses":["others_legend"]},{"text":"Business unit","cssclasses":["business_unit_legend"]}],"cssclasses":[]}]
    }

    // bbox(d) {
    //     //console.log("bbox called");
    //     return fetch(`${Endpoints.TILE_META}/bbox`, {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json"
    //         },
    //         body: JSON.stringify(d ?? {})
    //     }).then(res => res.json());
    // }

    resize() {
        if (this.map) {
            this.map.resize();
        }
    }

    setupContextVectorTiles(map) {
        window.map = map;
        const { sources, contextLayers } = this.props;
        (sources ?? []).forEach(source => {
            const _source = source.type === "geojson" ? _.omit(source, "id") : source;

            map.addSource(source.id, _source);
        });
        (contextLayers ?? []).forEach(contextLayer => {
            map.addLayer(contextLayer);
        });
    }

    // getBounds(layers = [], maxBounds) {
    //     if (maxBounds) return maxBounds();

    //     const fCol = {
    //         type: "FeatureCollection",
    //         features: []
    //     };

    //     layers.forEach(layer => {
    //         const { data } = layer;
    //         const { features } = data;
    //         features.forEach(feature => fCol.features.push(feature));
    //     });

    //     const bbox = tbbox(fCol);

    //     return [
    //         [bbox[0], bbox[1]],
    //         [bbox[2], bbox[3]]
    //     ];
    // }

    drawMap() {
        const that = this;
        // console.log(this.isCancelled);

        if (this.isCancelled) return;
        // console.log("drawing map");

        const { maxBounds, flyTo, showLegend = false, center, minZoom, maxZoom, scrollZoom = true } = this.props;

        const element = this.element.current;
        const width = element.offsetWidth;
        const height = element.offsetHeight;

        const mapContent = element.getElementsByClassName("map-content")[0];
        //d3.select(mapContent).style("width", width + "px");

        let legendHeight = 0;
        if (showLegend) {
            let legendDivBBox = d3.select(element).select(".map-legend").node().getBoundingClientRect();
            legendHeight = legendDivBBox.height;
        }

        const mapContentHeight = Math.floor(height - legendHeight);
        //console.log(width);

        d3.select(mapContent).style("width", width + "px");
        d3.select(mapContent).style("height", mapContentHeight + "px");

        const _center = center || [148.271484375, -21.637005211106306];
        const _minZoom = minZoom == null ? this.minZoom : minZoom;
        const _maxZoom = maxZoom == null ? this.maxZoom : maxZoom;
        if (!this.map) {
            // mapboxgl.accessToken = "pk.eyJ1IjoibnljZG90IiwiYSI6IlhHQjNQRWMifQ.cz7P1kLgUTLOlt9Lc1RQvQ";
            mapboxgl.accessToken =
                //     "pk.eyJ1IjoidHJ1aWkiLCJhIjoiY2tsdm5yZms4MGZhczJ2bnZmZm94dmg2ZCJ9.qIHV5Gk1jssedlc5PedWqw";
                "pk.eyJ1IjoidHJ1aWkiLCJhIjoiY20yYmZscnV0MDR5MjJsb2ZzemVtaXd4NiJ9.IP2b8p4cQvavFISeY1ZQ8A";

            let map = new mapboxgl.Map({
                container: mapContent,
                style: {
                    version: 8,
                    name: "Klokantech Basic",
                    metadata: {},
                    sources: {},
                    layers: [],
                    id: "klokantech-basic",
                    glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
                },
                center: _center,
                minZoom: _minZoom,
                maxZoom: _maxZoom
            });

            // disable map rotation using right click + drag
            map.dragRotate.disable();

            // disable map rotation using touch rotation gesture
            map.touchZoomRotate.disableRotation();

            // disable map zoom when using scroll
            scrollZoom === false && map.scrollZoom.disable();
            scrollZoom === false && map.dragRotate.disable();
            scrollZoom === false && map.dragPan.disable();
            scrollZoom === false && map.doubleClickZoom.disable();

            this.map = map;

            //map.showTileBoundaries = true;

            map.on("load", function () {
                that.setupContextVectorTiles(map);
                that.contextLoaded = true;

                //   if (maxBounds) {
                //       setTimeout(function(){
                //           map.fitBounds(maxBounds(), {
                //           }, {fitBounds: true});
                //       }, 1500);
                //   }
            });

            map.on("moveend", event => {
                // if (event.fitBounds === true) {
                //     map.setMaxBounds(map.getBounds());
                // }
            });

            map.on("viewreset", this.update);
            map.on("move", this.update);
            map.on("moveend", this.update);
        } else {
            minZoom != null && this.map.setMinZoom(_minZoom);
            maxZoom != null && this.map.setMaxZoom(_maxZoom);
            this.map.resize();

            //     this.bbox().then(d => {
            //         const { bbox } = d;

            //         return [
            //             [bbox[0], bbox[1]],
            //             [bbox[2], bbox[3]]
            //         ];
            //     }).then(d => {
            //         // console.log("set max bounds");
            //         // console.log(d);
            //         if (that.map) {
            //             //that.map.fitBounds(d);
            //             that.map.setMaxBounds([
            //                 [   131.220703125,
            //   -31.503629305773018],
            //                 [  166.025390625,
            //   -5.528510525692789]
            //             ]);
            //             // that.map.setMinZoom(0);
            //         }
            //     });

            if (that.map) {
                maxBounds && that.map.setMaxBounds(maxBounds);
                // flyTo && that.map.fitBounds(flyTo);
                // that.map.setMinZoom(0);
            }

            // this.map.setMaxBounds(this.getBounds(layers, maxBounds));
            // if (flyTo)
            //     this.map.flyTo(
            //         {
            //             center: flyTo()
            //         });
        }

        // draw svg layer
        if (this.map) {
            if (this.canvas) {
                //this.drawSVGLayer();
            } else {
                this.map.on("load", function () {
                    that.canvas = element.getElementsByClassName("mapboxgl-canvas")[0];
                    //that.drawSVGLayer();
                });
            }

            // setup geojson layer

            if (this.contextLoaded) {
                this.setupGeoJsonData();
            } else {
                this.map.on("load", function () {
                    that.setupGeoJsonData();
                });
            }
        }
    }

    // featureClickHandler(e) {
    //     const fo = (e.features || [])[0];
    //     const { onFeatureClick: _onFeatureClick } = this.props;

    //     if (fo && fo.properties && fo.properties[layer.spatialKey] !== null &&
    //         fo.properties[layer.spatialKey] !== undefined && _onFeatureClick) {

    //         const fLink = _onFeatureClick({
    //             feature: fo,
    //             code: fo.properties[layer.spatialKey]
    //         });

    //         if (fLink !== null && fLink !== undefined) {
    //             history.push(fLink);
    //         }
    //     }
    // }

    setupGeoJsonData() {
        // console.log("setup geojson");

        const that = this;

        if (!that.map || !that.map.getLayer) {
            // console.error("trace this problem");
            return;
        }

        const {
            showLegend = false,
            source,
            sources,
            showTooltip = false,
            hover = null,
            zoomed = false,
            afterDrawn,
            maxScale = 8,
            layers = [],
            colorMappings,
            history,
            onFeatureClick
        } = this.props;

        // const sourceIdToSource = _.keyBy(sources, d=>d.id);
        const isGeojson = () => {
            const sourceIdToSource = _.keyBy(this.props.sources ?? [], d => d.id);

            return sourceId => {
                return sourceIdToSource?.[sourceId]?.type === "geojson";
            };
        };

        let layersU = layers.map(layer => {
            var tLayer = {};
            for (var prop in layer) {
                tLayer[prop] = layer[prop];
            }

            // const { data, selection, focusSelection, spatialKey } = layer;
            // const hashFeatures = _.keyBy(data.features || [], function (feature) {
            //     return ((feature || {}).properties || {})[spatialKey];
            // });

            // tLayer.hashFeatures = hashFeatures;

            // tLayer.data.features.forEach((feature, index) => {
            //     //feature.id = ((feature || {}).properties || {})[spatialKey];
            //     feature.id = index.toString();
            // });

            // tLayer.filteredData = {
            //     type: "FeatureCollection",
            //     features: (selection || []).map(sel => {
            //         return hashFeatures[sel]
            //     }).filter(d => d != null)
            // };

            // tLayer.focusedData = {
            //     type: "FeatureCollection",
            //     features: (focusSelection || []).map(sel => {
            //         return hashFeatures[sel]
            //     }).filter(d => d != null)
            // };

            return tLayer;
        });

        const setupForPoints = (
            layer,
            { featureClickHandler, featureMouseLeaveHandler, featureMouseMoveHandler, featureMouseOverHandler }
        ) => {
            if (layer.type !== "point") return;

            const geojsonChecker = isGeojson();
            const source = layer.source;
            const sourceLayer = layer["source-layer"];

            let { spatialValues = [], idExtractedField, valueExtractedField } = layer;

            // re-visit colors
            spatialValues = spatialValues.map(d => {
                return {
                    key: d[idExtractedField] || "",
                    value: d[valueExtractedField] || "",
                    color: colorMappings[d[valueExtractedField]] || colorMappings["default"] || that.notFoundValueColor,
                    data: d
                };
            });

            that.hashedSpatialValues[layer.id] = spatialValues;

            if (!that.map.getLayer(layer.id)) {
                // one layer for current (selected one)
                const currentSelectedLayer = {
                    id: "current" + layer.id,
                    source: layer.source,
                    ...(layer["source-layer"] && !geojsonChecker(layer.source)
                        ? {
                              "source-layer": layer["source-layer"]
                          }
                        : {}),

                    type: "circle",
                    paint: {
                        "circle-radius": layer.radius,
                        "circle-stroke-color": layer.clickedPolygonStroke,
                        "circle-stroke-width": layer.clickedPolygonStrokeWidth,
                        "circle-stroke-opacity": layer.clickedPolygonStrokeOpacity
                    }
                };

                // that.map.addLayer(currentSelectedLayer, "waterwayLabels");
                that.map.addLayer(currentSelectedLayer, "pointFake");

                // one layer for hovering ones
                const hoverFillLayer = {
                    id: "hover-" + layer.id,
                    source: layer.source,
                    ...(layer["source-layer"] && !geojsonChecker(layer.source)
                        ? {
                              "source-layer": layer["source-layer"]
                          }
                        : {}),

                    type: "circle",
                    paint: {
                        "circle-opacity": 0,
                        "circle-radius": layer.radius,
                        "circle-stroke-color": layer.mouseEnterPolygonStroke,
                        "circle-stroke-width": layer.mouseEnterPolygonStrokeWidth,
                        "circle-stroke-opacity": layer.mouseEnterPolygonStrokeOpacity
                    }
                };

                that.map.addLayer(hoverFillLayer, "current" + layer.id);

                // one layer for displaying ones
                const fillLayer = {
                    id: layer.id,
                    source: layer.source,
                    ...(layer["source-layer"] && !geojsonChecker(layer.source)
                        ? {
                              "source-layer": layer["source-layer"]
                          }
                        : {}),

                    type: "circle",
                    paint: {
                        "circle-radius": layer.radius,
                        "circle-stroke-color": layer.mouseOutPolygonStroke,
                        "circle-stroke-width": layer.mouseOutPolygonStrokeWidth,
                        "circle-stroke-opacity": layer.mouseOutPolygonStrokeOpacity,
                        "circle-opacity": 0
                    }
                };

                // that.map.addLayer(
                //     {
                //         id: layer.id + "-symbol",
                //         source: "scheme-tile",
                //         "source-layer": "schemes",
                //         type: "symbol",
                //         layout: {
                //             // Set the label content to the
                //             // feature's `name` property
                //             "text-field": "5"
                //         }
                //     },
                //     "waterway"
                // );

                that.map.addLayer(fillLayer, "hover-" + layer.id);

                [layer.id].forEach((lid, index) => {
                    if (index === 0) {
                        that.map.on("click", lid, featureClickHandler);
                    }
                    that.map.on("mousemove", lid, featureMouseMoveHandler);

                    that.map.on("mouseleave", lid, featureMouseLeaveHandler);

                    that.map.on("mouseover", lid, featureMouseOverHandler);
                });
            }
        };

        const setupColorForPoints = layer => {
            if (layer.type !== "point") return;

            // update paint properties from the table values
            let { spatialValues = [], idExtractedField, valueExtractedField } = layer;

            // re-visit colors
            spatialValues = spatialValues.map(d => {
                return {
                    key: d[idExtractedField] || "",
                    value: d[valueExtractedField] || "",
                    color: colorMappings[d[valueExtractedField]] || colorMappings["default"] || that.notFoundValueColor,
                    data: d
                };
            });

            let _selection = ["in", layer.spatialKey];
            layer.selection.forEach(sel => _selection.push(sel));

            let _current = ["in", layer.spatialKey];
            if (Array.isArray(layer.current)) layer.current.forEach(curr => _current.push(curr));
            else _current.push(layer.current);

            // console.log(layer.id, ["all", _selection]);
            that.map.setFilter(
                layer.id,
                [
                    "any",
                    _selection,
                    layer.featureGroupingSelection
                    // ["in", "lookup", "Cairns Regional Council ### Potable water scheme"]
                ].filter(d => d != null)
            );

            that.map.setFilter(
                "current" + layer.id,
                [
                    "any",
                    // ["in", layer.spatialKey, layer.current]
                    _current
                    // layer.featureGroupingSelection
                ].filter(d => d != null)
            );

            that.map.setPaintProperty("current" + layer.id, "circle-stroke-color", layer.clickedPolygonStroke);
            that.map.setPaintProperty("current" + layer.id, "circle-stroke-width", layer.clickedPolygonStrokeWidth);
            that.map.setPaintProperty("current" + layer.id, "circle-stroke-opacity", layer.clickedPolygonStrokeOpacity);

            let fillColorProp = colorMappings["default"] || that.notFoundValueColor;
            let _fillColorProp = d3
                .hsl(fillColorProp)
                .brighter(1 - layer.mouseEnterPolygonFillOpacity)
                .toString();

            if (spatialValues && spatialValues.length > 0) {
                // console.log("spatial values exist");
                let _spatialValues = _.keyBy(spatialValues, d => d.key);

                fillColorProp = ["match", ["get", layer.spatialKey]];
                _fillColorProp = ["match", ["get", layer.spatialKey]];

                for (var prop in _spatialValues) {
                    fillColorProp.push(_spatialValues[prop].key);
                    fillColorProp.push(_spatialValues[prop].color);

                    _fillColorProp.push(_spatialValues[prop].key);
                    _fillColorProp.push(
                        d3
                            .hsl(_spatialValues[prop].color)
                            .brighter(1 - layer.mouseEnterPolygonFillOpacity)
                            .toString()
                    );
                }

                fillColorProp.push(colorMappings["default"] || that.notFoundValueColor);
                _fillColorProp.push(
                    d3
                        .hsl(colorMappings["default"] || that.notFoundValueColor)
                        .brighter(1 - layer.mouseEnterPolygonFillOpacity)
                        .toString()
                );
            }

            // console.log(fillColorProp, layer.mouseOutPolygonFillOpacity);

            that.map.setPaintProperty(layer.id, "circle-color", fillColorProp);
            that.map.setPaintProperty(layer.id, "circle-opacity", layer.mouseOutPolygonFillOpacity);

            that.map.setPaintProperty("current" + layer.id, "circle-color", fillColorProp);
            that.map.setPaintProperty("current" + layer.id, "circle-opacity", layer.mouseOutPolygonFillOpacity);

            that.map.setFilter(
                "hover-" + layer.id,
                [
                    "any",
                    ["in", layer.spatialKey, ""]
                    // layer.featureGroupingSelection
                ].filter(d => d != null)
            );

            // that.map.setFilter("hover-line-" + layer.id, [
            //     "all",
            //     ["in", layer.spatialKey, ""]
            // ]);

            //that.map.setPaintProperty('hover-' + layer.id, 'fill-opacity', 0);

            that.map.setPaintProperty("hover-" + layer.id, "circle-opacity", 1);
            that.map.setPaintProperty("hover-" + layer.id, "circle-color", _fillColorProp);

            // console.log(_fillColorProp);
            let { updateFn } = that.props;
            if (updateFn) {
                updateFn({ color: fillColorProp, map: that.map });
            }
        };

        layersU.forEach(layer => {
            const source = layer.source;
            const sourceLayer = layer["source-layer"];

            // update paint properties from the table values
            let { spatialValues = [], idExtractedField, valueExtractedField } = layer;
            // re-visit colors
            spatialValues = spatialValues.map(d => {
                return {
                    key: d[idExtractedField] ?? "",
                    value: d[valueExtractedField] ?? "",
                    color: colorMappings[d[valueExtractedField]] ?? colorMappings["default"] ?? that.notFoundValueColor,
                    data: d
                };
            });

            that.hashedSpatialValues[layer.id] = spatialValues;

            const featureClickHandler = function (e) {
                const fo = (e.features ?? [])[0];
                const { onFeatureClick: _onFeatureClick } = that.props;

                let _values = (that.hashedSpatialValues ?? {})[layer.id] ?? [];
                _values = _.keyBy(_values, d => d.key);

                const key = ((fo ?? {}).properties ?? {})[layer.spatialKey];

                const value = ((_values ?? {})[key] ?? {}).value;
                const data = ((_values ?? {})[key] ?? {}).data;

                if (
                    fo &&
                    fo.properties &&
                    fo.properties[layer.spatialKey] !== null &&
                    fo.properties[layer.spatialKey] !== undefined &&
                    _onFeatureClick
                ) {
                    const fLink = _onFeatureClick({
                        feature: fo,
                        code: fo.properties[layer.spatialKey],
                        data,
                        value
                    });

                    // if (fLink !== null && fLink !== undefined) {
                    //     history.push(fLink);
                    // }
                }
                // console.log(that.map.queryRenderedFeatures(e.point, {
                //     layers: [layer.id]
                // }));
                //history.push("/home?report=overview");
            };

            const featureMouseMoveHandler = function (e) {
                let _values = (that.hashedSpatialValues ?? {})[layer.id] ?? [];
                _values = _.keyBy(_values, d => d.key);
                //console.log(e);
                if (e.features.length > 0) {
                    // console.log(new VectorTile(new Pbf(e.features[0]._vectorTileFeature._pbf)));
                    // d3.buffer('http://localhost:9000/regions_vis_all_levels.mbtiles/4/14/8.pbf').then(d=>{
                    //     console.log(new VectorTile(new Pbf(d)));
                    // })

                    // if (that.hoveredFeatureId) {
                    //     that.map.setFeatureState(
                    //         {
                    //             source: layer.id,
                    //             id: that.hoveredFeatureId
                    //         }, { hover: false });
                    // }

                    // that.hoveredFeatureId = e.features[0].id;
                    // that.map.setFeatureState({
                    //     source: layer.id,
                    //     id: that.hoveredFeatureId
                    // }, { hover: true });

                    const hoveredFeature = e.features[0];
                    try {
                        const _layer = that.map.getLayer("hover-" + layer.id);
                        _layer &&
                            that.map.setFilter(
                                "hover-" + layer.id,
                                [
                                    "any",
                                    [
                                        "in",
                                        layer.spatialKey,
                                        ((hoveredFeature ?? {}).properties ?? {})[layer.spatialKey] ?? ""
                                    ]

                                    // layer.featureGroupingSelection
                                ].filter(d => d != null)
                            );
                    } catch (err) {}
                    try {
                        const _layer = that.map.getLayer("hover-line-" + layer.id);
                        _layer &&
                            that.map.setFilter(
                                "hover-line-" + layer.id,
                                [
                                    "any",
                                    [
                                        "in",
                                        layer.spatialKey,
                                        ((hoveredFeature ?? {}).properties ?? {})[layer.spatialKey] ?? ""
                                    ]

                                    // layer.featureGroupingSelection
                                ].filter(d => d != null)
                            );
                    } catch (err) {}

                    // console.log([
                    //     "all",
                    //     ["in", layer.spatialKey, ((hoveredFeature || {}).properties || {})[layer.spatialKey] || ""]
                    // ]);
                }

                //console.log(e);
                if (showTooltip && hover) {
                    // that.map._canvas.style.cursor = "pointer";

                    const key = ((e.features[0] ?? {}).properties ?? {})[layer.spatialKey];
                    //document.body.style.cursor = "pointer";
                    that.map._canvas.classList.add("feature-hovered");
                    const { meta, legendMappings, hover } = that.props;
                    hover({
                        legendMappings,
                        key,
                        meta,
                        // feature: e.features[0],
                        features: e.features,
                        value: ((_values ?? {})[key] ?? {}).value,
                        data: ((_values ?? {})[key] ?? {}).data,
                        d3Tooltip: that.tooltip
                    });

                    // hover({
                    //     id: objId,
                    //     value: d.values.get(objId),
                    //     legends: d.metaGroup.legendMappings,
                    //     d3Element: that.tooltip,
                    //     spatialValues: d.metaGroup.spatialValues,
                    //     idExtractedField: d.metaGroup.idExtractedField,
                    //     colorMappings: d.metaGroup.colorMappings
                    // });

                    locateTooltip({ d3Tooltip: that.tooltip, event: e.originalEvent });
                }
            };

            const featureMouseLeaveHandler = function (e) {
                // that.map._canvas.style.cursor = "grab";
                //document.body.style.cursor = "inherit";
                that.map._canvas.classList.remove("feature-hovered");

                // if (that.hoveredFeatureId) {
                //     that.map.setFeatureState({
                //         source: layer.id, id: that.hoveredFeatureId
                //     }, { hover: false });
                // }
                // that.hoveredFeatureId = null;

                const hoverLayer = that.map.getLayer("hover-" + layer.id);
                hoverLayer &&
                    that.map.setFilter(
                        "hover-" + layer.id,
                        [
                            "any",
                            ["in", layer.spatialKey, ""]
                            // layer.featureGroupingSelection
                        ].filter(d => d != null)
                    );

                const hoverLineLayer = that.map.getLayer("hover-line-" + layer.id);
                hoverLineLayer &&
                    that.map.setFilter(
                        "hover-line-" + layer.id,
                        [
                            "any",
                            ["in", layer.spatialKey, ""]
                            // layer.featureGroupingSelection
                        ].filter(d => d != null)
                    );

                that.tooltip.style("display", "none");
            };

            const featureMouseOverHandler = function (e) {
                that.tooltip
                    .transition()
                    .duration(300)
                    .styleTween("opacity", function (d) {
                        if (this._current === null || this._current === undefined) {
                            this._current = 0;
                        }

                        var interpolate = d3.interpolate(this._current, 0.9);
                        this._current = interpolate(0);
                        return function (t) {
                            return interpolate(t);
                        };
                    });
            };

            if (!that.map.getLayer(layer.id) && layer.type === "point") {
                setupForPoints(layer, {
                    featureClickHandler,
                    featureMouseLeaveHandler,
                    featureMouseMoveHandler,
                    featureMouseOverHandler
                });
            } else if (!that.map.getLayer(layer.id)) {
                let sourceData = {};

                // if (source !== null && source !== undefined && sourceLayer !== null && sourceLayer !== undefined) {
                //     sourceData["source"] = source;
                //     sourceData["source-layer"] = sourceLayer;
                // } else {

                // geojson source
                // that.map.addSource(layer.id, {
                //     type: "geojson",
                //     data: layer.data
                // });
                // sourceData["source"] = layer.id;
                // }

                const geojsonChecker = isGeojson();

                const currentSelectedLayer = {
                    id: "current" + layer.id,
                    source: layer.source,
                    // "source-layer": layer["source-layer"],
                    ...(layer["source-layer"] && !geojsonChecker(layer.source)
                        ? {
                              "source-layer": layer["source-layer"]
                          }
                        : {}),

                    type: "line",
                    paint: {
                        "line-color": layer.clickedPolygonStroke,
                        "line-width": layer.clickedPolygonStrokeWidth,
                        "line-opacity": layer.clickedPolygonStrokeOpacity
                    }
                };

                that.map.addLayer(currentSelectedLayer, "waterwayLabels");

                const hoverFillLayer = {
                    id: "hover-" + layer.id,
                    type: "fill",
                    source: layer.source,
                    // "source-layer": layer["source-layer"],

                    ...(layer["source-layer"] && !geojsonChecker(layer.source)
                        ? {
                              "source-layer": layer["source-layer"]
                          }
                        : {}),

                    paint: {
                        "fill-opacity": 1
                    },
                    filter: ["all", ["in", "NAME", ""]]
                };

                that.map.addLayer(hoverFillLayer, "ocean");

                const hoverLineLayer = {
                    id: "hover-line-" + layer.id,
                    type: "line",
                    source: layer.source,
                    // "source-layer": layer["source-layer"],

                    ...(layer["source-layer"] && !geojsonChecker(layer.source)
                        ? {
                              "source-layer": layer["source-layer"]
                          }
                        : {}),

                    paint: {
                        "line-color": layer.mouseEnterPolygonStroke,
                        "line-width": layer.mouseEnterPolygonStrokeWidth,
                        "line-opacity": layer.mouseEnterPolygonStrokeOpacity
                    },
                    filter: ["all", ["in", "NAME", ""]]
                };

                that.map.addLayer(hoverLineLayer, "current" + layer.id);

                const fillLayer = {
                    id: layer.id,
                    type: "fill",
                    // source: sourceData.source, -> geojson layer
                    //"source-layer": sourceData["source-layer"],

                    source: layer.source,
                    // "source-layer": layer["source-layer"],

                    ...(layer["source-layer"] && !geojsonChecker(layer.source)
                        ? {
                              "source-layer": layer["source-layer"]
                          }
                        : {}),

                    paint: {
                        // 'fill-color': ["case",
                        //     ["boolean", ["feature-state", "visibility"], false],
                        //     "red",
                        //     "green"
                        // ],
                        //'fill-color': ["string", ["feature-state", "featureColor"], that.notFoundValueColor, "white"],
                        "fill-color": colorMappings["default"] ?? that.notFoundValueColor,
                        "fill-opacity": 0
                        //"fill-color": "red"
                        //'fill-outline-color': 'yellow',
                        // 'line-color': "red",
                        // 'line-width': 1,
                        // 'line-opacity': 0.75
                    }

                    // tLayer.visibility = ["case",
                    //     ["boolean", ["feature-state", "visibility"], false],
                    //     "visible",
                    //     "none"
                    // ]
                };

                that.map.addLayer(fillLayer, "hover-" + layer.id);
                //that.map.addLayer(fillLayer, 'ocean');

                const lineLayer = {
                    id: "line-" + layer.id,
                    type: "line",
                    source: layer.source,
                    // "source-layer": layer["source-layer"],
                    ...(layer["source-layer"] && !geojsonChecker(layer.source)
                        ? {
                              "source-layer": layer["source-layer"]
                          }
                        : {}),

                    paint: {
                        // 'line-color': ["case",
                        //     ["boolean", ["feature-state", "hover"], false],
                        //     COLOR.MOUSEOUT_POLYGON_STROKE,
                        //     COLOR.MOUSEENTER_POLYGON_STROKE
                        // ],

                        "line-color": layer.mouseOutPolygonStroke,
                        // 'line-width': ["case",
                        //     ["boolean", ["feature-state", "hover"], false],
                        //     3,
                        //     1
                        // ],
                        "line-width": layer.mouseOutPolygonStrokeWidth,
                        "line-opacity": layer.mouseOutPolygonStrokeOpacity
                    }
                };

                that.map.addLayer(lineLayer, "hover-line-" + layer.id);

                //that.map.addLayer(lineLayer, 'waterwayLabels');

                // When the user moves their mouse over the state-fill layer, we'll update the
                // feature state for the feature under the mouse.
                [layer.id, "line-" + layer.id].forEach((lid, index) => {
                    if (index === 0) {
                        that.map.on("click", lid, featureClickHandler);
                    }
                    that.map.on("mousemove", lid, featureMouseMoveHandler);

                    that.map.on("mouseleave", lid, featureMouseLeaveHandler);

                    that.map.on("mouseover", lid, featureMouseOverHandler);
                });

                // When the mouse leaves the state-fill layer, update the feature state of the
                // previously hovered feature.
                // [layer.id, 'line-' + layer.id].forEach(lid => {
                //     that.map.on("mouseleave", lid, function (e) {
                //         if (that.hoveredFeatureId) {
                //             that.map.setFeatureState({
                //                 source: layer.id, id: that.hoveredFeatureId
                //             }, { hover: false });
                //         }
                //         that.hoveredFeatureId = null;

                //         that.tooltip.style('display', 'none');
                //     });
                // });
            } else {
                //  [layer.id, 'line-' + layer.id].forEach((lid, index) => {
                //     if (index === 0) {
                //         that.map.off("click", lid, featureClickHandler);
                //         that.map.on("click", lid, featureClickHandler);
                //     }
                //     that.map.off("mousemove", lid, featureMouseMoveHandler);
                //     that.map.on("mousemove", lid, featureMouseMoveHandler);
                //     that.map.off("mouseleave", lid, featureMouseLeaveHandler);
                //     that.map.on("mouseleave", lid, featureMouseLeaveHandler);
                //     that.map.off("mouseover", lid, featureMouseOverHandler);
                //     that.map.on("mouseover", lid, featureMouseOverHandler);
                // });
            }

            // that.map.on("render", function(e){
            //     console.log(e);

            //     if (!that.featuresMap)
            //         that.featuresMap = {};
            //     that.featuresMap[layer.id] = that.map.queryRenderedFeatures({layers:[layer.id]});

            //     let features = that.featuresMap[layer.id];
            //     console.log(features);
            // });

            // filter by selected features
            if (layer.type === "point") {
                setupColorForPoints(layer);
            } else {
                let _selection = ["in", layer.spatialKey];
                layer.selection.forEach(sel => _selection.push(sel));

                that.map.setFilter(
                    layer.id,
                    ["any", _selection, layer.featureGroupingSelection].filter(d => d != null)
                );

                that.map.setFilter(
                    "line-" + layer.id,
                    ["any", _selection, layer.featureGroupingSelection].filter(d => d != null)
                );

                that.map.setFilter(
                    "current" + layer.id,
                    [
                        "any",
                        ["in", layer.spatialKey, layer.current]
                        // , layer.featureGroupingSelection
                    ].filter(d => d != null)
                );

                that.map.setPaintProperty("current" + layer.id, "line-color", layer.clickedPolygonStroke);
                that.map.setPaintProperty("current" + layer.id, "line-width", layer.clickedPolygonStrokeWidth);
                that.map.setPaintProperty("current" + layer.id, "line-opacity", layer.clickedPolygonStrokeOpacity);

                let fillColorProp = colorMappings["default"] ?? that.notFoundValueColor;
                let _fillColorProp = d3
                    .hsl(fillColorProp)
                    .brighter(1 - layer.mouseEnterPolygonFillOpacity)
                    .toString();

                if (spatialValues && spatialValues.length > 0) {
                    // console.log("spatial values exist");
                    let _spatialValues = _.keyBy(spatialValues, d => d.key);

                    fillColorProp = ["match", ["get", layer.spatialKey]];
                    _fillColorProp = ["match", ["get", layer.spatialKey]];

                    for (var prop in _spatialValues) {
                        fillColorProp.push(_spatialValues[prop].key);
                        fillColorProp.push(_spatialValues[prop].color);

                        _fillColorProp.push(_spatialValues[prop].key);
                        _fillColorProp.push(
                            d3
                                .hsl(_spatialValues[prop].color)
                                .brighter(1 - layer.mouseEnterPolygonFillOpacity)
                                .toString()
                        );
                    }

                    fillColorProp.push(colorMappings["default"] ?? that.notFoundValueColor);

                    _fillColorProp.push(
                        d3
                            .hsl(colorMappings["default"] ?? that.notFoundValueColor)
                            .brighter(1 - layer.mouseEnterPolygonFillOpacity)
                            // .brighter(0)
                            .toString()
                    );

                    // fillColorProp.push("white");
                    //_fillColorProp.push(d3.hsl("red").brighter((1 - layer.mouseEnterPolygonFillOpacity)).toString());
                }

                that.map.setPaintProperty(layer.id, "fill-color", fillColorProp);
                that.map.setPaintProperty(layer.id, "fill-opacity", layer.mouseOutPolygonFillOpacity);

                that.map.setFilter(
                    "hover-" + layer.id,
                    [
                        "any",
                        ["in", layer.spatialKey, ""]
                        // layer.featureGroupingSelection
                    ].filter(d => d != null)
                );

                that.map.setFilter(
                    "hover-line-" + layer.id,
                    [
                        "any",
                        ["in", layer.spatialKey, ""]
                        // layer.featureGroupingSelection
                    ].filter(d => d != null)
                );

                //that.map.setPaintProperty('hover-' + layer.id, 'fill-opacity', 0);
                that.map.setPaintProperty("hover-" + layer.id, "fill-opacity", 1);
                that.map.setPaintProperty("hover-" + layer.id, "fill-color", _fillColorProp);

                let { updateFn } = that.props;
                if (updateFn) {
                    updateFn({ color: fillColorProp, map: that.map });
                }
            }

            that.props?.setupExtraLayers?.(that.map);

            // setTimeout(function(){
            //     that.map.setPaintProperty('hover-' + layer.id, 'fill-opacity', 1);
            // }, 300);

            //that.map.setPaintProperty('hover-' + layer.id, 'fill-opacity', 1);

            /*
            // ---> geojson layer
            let _selection = ["in", layer.spatialKey];
            layer.selection.forEach(sel => _selection.push(sel));

            that.map.setFilter(layer.id, [
                "all",
                _selection
            ]);

            that.map.setFilter('line-' + layer.id, [
                "all",
                _selection
            ]);

            let { spatialValues, idExtractedField, valueExtractedField } = layer;
            spatialValues = spatialValues.map(d => {
                return {
                    key: d[idExtractedField] || "",
                    value: d[valueExtractedField] || "",
                    color: colorMappings[d[valueExtractedField]] ||
                        colorMappings["default"] || that.notFoundValueColor || "red"
                }
            })

            // create {[code]: {value, color}}
            spatialValues = _.keyBy(spatialValues, d => d.key);

            const _sel = {};
            layer.selection.forEach(function (sel) { _sel[sel] = 1 });

            let _features = (layer.data || { features: null }).features || [];

            _features.filter(f => _sel[((f || {}).properties || {})[layer.spatialKey]] === 1)
                .forEach(f => {
                    const key = ((f || {}).properties || {})[layer.spatialKey];
                    that.map.setFeatureState({ id: f.id, source: layer.id }, {
                        featureColor: (spatialValues[key] || { color: colorMappings["default"] || that.notFoundValueColor }).color
                    })
                });*/

            // .forEach(f=>{
            //     const key = _sel[((f || {}).properties || {})[layer.spatialKey]];
            //     that.map.setFeatureState({id: f.id, source: layer.id}, {
            //         featureColor: (spatialValues[key] || {color: that.notFoundValueColor}).color
            //     })
            // })

            // that.map.setFeatureState({id: f.id, source: layer.id}, {
            //          visibility: _sel[((f || {}).properties || {})[layer.spatialKey]] === 1? true: false
            //      })

            // if (!that.map.getSource(layer.id)){
            //     that.map.removeSource(layer.id);
            // }

            // const bbox = turf.bbox(layer.focusedData);

            // that.map.fitBounds([[bbox[0], bbox[1]],
            // [bbox[2], bbox[3]]
            // ], {});
        });

        const allFocuses = layersU.map(layer => {
            return (layer ?? {}).focusSelection ?? [];
        });

        // const displayedAdminIds = layersU.map(layer => {
        //     return (layer ?? {}).selection ?? [];
        // });

        if (this.props.findBounds) {
            const propValues = _.uniq(_.flatten(allFocuses));
            // const _displayedAdminIds = _.uniq(_.flatten(displayedAdminIds));

            this.props
                .findBounds({
                    // propValues: propValues?.length > 0 ? propValues : _displayedAdminIds,
                    propValues,
                    propKey: ((layersU ?? [])[0] ?? {}).spatialKey
                })
                .then(d => {
                    const { bbox } = d;
                    if (bbox.length === 0) return [];

                    return [
                        [bbox[0], bbox[1]],
                        [bbox[2], bbox[3]]
                    ];
                })
                .then(d => {
                    if (d && that.map && d.length === 2)
                        that.map.fitBounds(
                            d,
                            this.props.fitBoundsSettings ?? {
                                padding: { top: 10, bottom: 10, left: 10, right: 10 }
                            }
                        );
                });
        }

        window["temp"] = that.map;
    }

    update() {}
}

export const JSBaseMap = Map;
